// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3goTS","detailOffset":"style_detailOffset__2kHXL"};